import {
  LIBRARY_ITEM_PAGE_REQUEST,
  LIBRARY_ITEM_ITEM_SUMMARY_REQUEST,
  LIBRARY_ITEM_CHANGE_CATEGORY_ID_DROPDOWN,
  LIBRARY_ITEM_CHANGE_INVENTORY_ID_DROPDOWN,
  LIBRARY_ITEM_SET_ITEM_SUMMARY,
  LIBRARY_ITEM_LIST_ITEM_REQUEST,
  LIBRARY_ITEM_SET_ITEM_LIST,
  LIBRARY_ITEM_SET_CATEGORY_LIST,
  LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID,
  LIBRARY_ITEM_LIST_CATEGORY_REQUEST,
  LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
  LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID,
  LIBRARY_ITEM_SET_OUTLETS,
  LIBRARY_ITEM_SET_FILTER_STATE,
  LIBRARY_ITEM_SET_FILTER_ITEM,
  LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS,
  LIBRARY_ITEM_SET_CURRENT_PAGE,
  LIBRARY_ITEM_SET_TOTAL_PAGE,
  LIBRARY_ITEM_UNSET_FILTER_STATE,
  LIBRARY_ITEM_ITEM_LIST_EXPORT,
  LIBRARY_ITEM_SET_TYPE_IMPORT,
  LIBRARY_ITEM_SHOW_SECTION_UPLOADER,
  LIBRARY_ITEM_ITEM_LIST_TEMPLATE,
  LIBRARY_ITEM_OPEN_RIGHT_COLUMN,
  LIBRARY_ITEM_CLOSE_RIGHT_COLUMN,
  LIBRARY_ITEM_SET_ITEM_DETAIL,
  LIBRARY_ITEM_ON_CLICK_CANCEL,
  LIBRARY_ITEM_ON_DROP_IMAGE,
  LIBRARY_ITEM_ON_DELETE_IMAGE,
  LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT,
  LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_ON_CLICK_BTN_SALES_TYPE,
  LIBRARY_ITEM_SHOW_SALES_TYPE_MODAL,
  LIBRARY_ITEM_HIDE_SALES_TYPE_MODAL,
  LIBRARY_ITEM_ON_CANCEL_SALES_TYPE_MODAL,
  LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_ITEM_SHOW_COGS_MODAL,
  LIBRARY_ITEM_HIDE_COGS_MODAL,
  LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM,
  LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_SALES_TYPE_MODAL,
  LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING,
  LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING,
  LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_ON_CANCEL_COGS_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL,
  LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM,
  LIBRARY_ITEM_SET_MODIFIER_FOR_DETAIL_ITEM,
  LIBRARY_ITEM_SET_MODIFIERS,
  LIBRARY_ITEM_SET_ACTIVE_MODIFIER_IDS,
  LIBRARY_ITEM_SET_MANAGE_ITEM_INVENTORY,
  LIBRARY_ITEM_SUBMIT_FORM_CREATE,
  LIBRARY_ITEM_SUBMIT_FORM_UPDATE,
  LIBRARY_ITEM_HIDE_UPDATE_MODAL,
  LIBRARY_ITEM_SHOW_UPDATE_MODAL,
  LIBRARY_ITEM_HIDE_DELETE_MODAL,
  LIBRARY_ITEM_SHOW_DELETE_MODAL,
  LIBRARY_ITEM_DELETE_ITEM,
  LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_ON_CLICK_CREATE_NEW_BRAND,
  LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL,
  LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL,
  LIBRARY_ITEM_SET_NEW_CATEGORY,
  LIBRARY_ITEM_SET_NEW_BRAND,
  LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY,
  LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES,
  LIBRARY_ITEM_SET_PREVIOUS_BRAND,
  LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID,
  LIBRARY_ITEM_SET_PREVIOUS_BRAND_ID,
  LIBRARY_ITEM_SHOW_IMPORT_MODAL,
  LIBRARY_ITEM_HIDE_IMPORT_MODAL,
  LIBRARY_ITEM_ON_SUCCESS_IMPORT,
  LIBRARY_ITEM_SET_MUST_SCROLL_TOP,
  LIBRARY_ITEM_SET_IS_SUBMITTING_FORM,
  LIBRARY_ITEM_SET_REWARD_ITEM_LIST,
  LIBRARY_ITEM_SET_REWARD_CATEGORY_LIST,
  LIBRARY_ITEM_SET_REWARD_ITEM_VARIANT_OF,
  LIBRARY_ITEM_SET_POINT_GAIN_ITEM_LIST,
  LIBRARY_ITEM_SET_POINT_GAIN_CATEGORY_LIST,
  LIBRARY_ITEM_SET_POINT_GAIN_ITEM_VARIANT_OF,
  LIBRARY_ITEM_ON_REDIRECT_SALES_TYPE,
  LIBRARY_ITEM_SET_VALIDATION_MODAL,
  LIBRARY_ITEM_SET_VALIDATION_MODAL_MESSAGE,
  LIBRARY_ITEM_ITEM_LIST_EXPORT_START,
  LIBRARY_ITEM_ITEM_LIST_EXPORT_FINISHED,
  LIBRARY_ITEM_ITEM_LIST_EXPORT_ERROR,
  LIBRARY_ITEM_SET_BRAND_LIST,
  LIBRARY_ITEM_CREATE_BRAND_SHOW_MODAL,
  LIBRARY_ITEM_CREATE_BRAND_HIDE_MODAL,
  LIBRARY_ITEM_CONFIRM_CREATE_NEW_BRAND,
  LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA_NO_SAGA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_INPUT,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA_NO_SAGA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_INPUT,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA_NO_SAGA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_INPUT,
  LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY_FASHION,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA_NO_SAGA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA_NO_SAGA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA_NO_SAGA,
  LIBRARY_ITEM_SET_ITEM_IS_RETAIL,
  LIBRARY_ITEM_SHOW_UPDATE_ALL_OUTLET_MODAL,
  LIBRARY_ITEM_HIDE_UPDATE_ALL_OUTLET_MODAL,
  LIBRARY_ITEM_SHOW_ERROR_UPDATE_ALL_OUTLET_MODAL,
  LIBRARY_ITEM_HIDE_ERROR_UPDATE_ALL_OUTLET_MODAL,
} from './constants';

export function pageRequest() {
  return { type: LIBRARY_ITEM_PAGE_REQUEST, payload: {} };
}

export function setMustScrollTop(mustScrollTop) {
  return { type: LIBRARY_ITEM_SET_MUST_SCROLL_TOP, payload: { mustScrollTop } };
}

export function itemsRequest(query, previousItems) {
  return {
    type: LIBRARY_ITEM_LIST_ITEM_REQUEST,
    payload: { query, previousItems },
  };
}

export function listCategoryRequest() {
  return { type: LIBRARY_ITEM_LIST_CATEGORY_REQUEST, payload: {} };
}

export function listCategoryWithUncategorizedRequest() {
  return {
    type: LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
    payload: {},
  };
}

export function itemSummaryRequest(query) {
  return { type: LIBRARY_ITEM_ITEM_SUMMARY_REQUEST, payload: query };
}

export function changeCategoryIdDropdown(categoryId) {
  return {
    type: LIBRARY_ITEM_CHANGE_CATEGORY_ID_DROPDOWN,
    payload: { categoryId },
  };
}

export function changeInventoryIdDropdown(inventoryId) {
  return {
    type: LIBRARY_ITEM_CHANGE_INVENTORY_ID_DROPDOWN,
    payload: { inventoryId },
  };
}

export function setItems(items) {
  return { type: LIBRARY_ITEM_SET_ITEM_LIST, payload: { items } };
}

export function setCategories(categories) {
  return { type: LIBRARY_ITEM_SET_CATEGORY_LIST, payload: { categories } };
}

export function setCurrentCategoryId(categoryId) {
  return {
    type: LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID,
    payload: { categoryId },
  };
}

export function setCurrentInventoryId(inventoryId) {
  return {
    type: LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID,
    payload: { inventoryId },
  };
}

export function setItemSummary(itemSummary) {
  return { type: LIBRARY_ITEM_SET_ITEM_SUMMARY, payload: { itemSummary } };
}

export function setOutlets(outlets) {
  return { type: LIBRARY_ITEM_SET_OUTLETS, payload: { outlets } };
}

export function setFilterState(categoryId, outletId, typeInventoryId, keyword) {
  return {
    type: LIBRARY_ITEM_SET_FILTER_STATE,
    payload: { categoryId, outletId, typeInventoryId, keyword },
  };
}

export function unSetFilterState() {
  return { type: LIBRARY_ITEM_UNSET_FILTER_STATE };
}

export function setFilterItem(categoryId, outletId, typeInventoryId, keyword) {
  return {
    type: LIBRARY_ITEM_SET_FILTER_ITEM,
    payload: { categoryId, outletId, typeInventoryId, keyword },
  };
}

export function onChangeOutletIds(outletIds) {
  return {
    type: LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds },
  };
}

export function setCurrentPage(currentPage) {
  return { type: LIBRARY_ITEM_SET_CURRENT_PAGE, payload: { currentPage } };
}

export function setTotalPage(totalPage) {
  return { type: LIBRARY_ITEM_SET_TOTAL_PAGE, payload: { totalPage } };
}

export function itemExportRequest(prefix, email, outlets, outlet, params) {
  return {
    type: LIBRARY_ITEM_ITEM_LIST_EXPORT,
    payload: { prefix, email, outlets, outlet, params },
  };
}

export function setImportType(importType) {
  return { type: LIBRARY_ITEM_SET_TYPE_IMPORT, payload: { importType } };
}

export function showSectionUploader(showSectionUploader) {
  return {
    type: LIBRARY_ITEM_SHOW_SECTION_UPLOADER,
    payload: { showSectionUploader },
  };
}

export function downloadItemTemplate(prefix, email, outlets) {
  return {
    type: LIBRARY_ITEM_ITEM_LIST_TEMPLATE,
    payload: { prefix, email, outlets },
  };
}

export function openRightColumn() {
  return { type: LIBRARY_ITEM_OPEN_RIGHT_COLUMN, payload: {} };
}

export function closeRightColumn() {
  return { type: LIBRARY_ITEM_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function setItemDetail(item) {
  return { type: LIBRARY_ITEM_SET_ITEM_DETAIL, payload: { item } };
}

export function onClickCancel() {
  return { type: LIBRARY_ITEM_ON_CLICK_CANCEL, payload: {} };
}

export function onDropImage(filesState) {
  return { type: LIBRARY_ITEM_ON_DROP_IMAGE, payload: { filesState } };
}

export function onDeleteImage(filesState) {
  return { type: LIBRARY_ITEM_ON_DELETE_IMAGE, payload: { filesState } };
}

export function onClickBtnItemVariant(itemForm) {
  return {
    type: LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT,
    payload: { itemForm },
  };
}

export function showItemVariantModal() {
  return { type: LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL, payload: {} };
}

export function hideItemVariantModal() {
  return { type: LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL, payload: {} };
}

export function showItemInventoryAleryModal() {
  return { type: LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL, payload: {} };
}

export function hideCOGSModal() {
  return { type: LIBRARY_ITEM_HIDE_COGS_MODAL, payload: {} };
}

export function showCOGSModal(isTrack) {
  return { type: LIBRARY_ITEM_SHOW_COGS_MODAL, payload: { isTrack } };
}

export function hideItemInventoryAlertModal() {
  return { type: LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL, payload: {} };
}

export function showSaveToAllOutletsModal() {
  return { type: LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

export function hideSaveToAllOutletsModal() {
  return { type: LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL, payload: {} };
}

export function setPreviousItemForm(previousItemForm) {
  return {
    type: LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM,
    payload: { previousItemForm },
  };
}

export function onCancelItemVariantModal(previousItemForm) {
  return {
    type: LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL,
    payload: { previousItemForm },
  };
}

export function onConfirmItemVariantModal(value) {
  return {
    type: LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL,
    payload: { value },
  };
}

export function onConfirmSalesTypeModal(value) {
  return { type: LIBRARY_ITEM_ON_CONFIRM_SALES_TYPE_MODAL, payload: { value } };
}

export function onClickBtnSalesType(itemForm, search, user, outlets) {
  return {
    type: LIBRARY_ITEM_ON_CLICK_BTN_SALES_TYPE,
    payload: { itemForm, search, user, outlets },
  };
}

export function showSalesTypeModal() {
  return { type: LIBRARY_ITEM_SHOW_SALES_TYPE_MODAL, payload: {} };
}

export function hideSalesTypeModal() {
  return { type: LIBRARY_ITEM_HIDE_SALES_TYPE_MODAL, payload: {} };
}

export function onCancelSalesTypeModal(previousItemForm) {
  return {
    type: LIBRARY_ITEM_ON_CANCEL_SALES_TYPE_MODAL,
    payload: { previousItemForm },
  };
}

export function onClickBtnStartTracking(itemForm, isTrack) {
  return {
    type: LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING,
    payload: { itemForm, isTrack },
  };
}

export function onClickBtnStartTrackingCOGS(itemForm, isTrack) {
  return {
    type: LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING,
    payload: { itemForm, isTrack },
  };
}

export function onCancelItemInventoryAlertModal(previousItemForm) {
  return {
    type: LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
    payload: { previousItemForm },
  };
}

export function onCancelCOGSModal(previousItemForm) {
  return {
    type: LIBRARY_ITEM_ON_CANCEL_COGS_MODAL,
    payload: { previousItemForm },
  };
}

export function onConfirmItemInventoryAlertModal(value, itemForm) {
  return {
    type: LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
    payload: { value, itemForm },
  };
}

export function onConfirmCOGSModal(value, isTrack) {
  return {
    type: LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL,
    payload: { value, isTrack },
  };
}

export function fillFormDetailItem(formatFormDetail) {
  return {
    type: LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM,
    payload: { formatFormDetail },
  };
}

export function getModifiersforItem(item) {
  return { type: LIBRARY_ITEM_SET_MODIFIER_FOR_DETAIL_ITEM, payload: { item } };
}

export function setModifiers(modifiers) {
  return { type: LIBRARY_ITEM_SET_MODIFIERS, payload: { modifiers } };
}

export function setManageItemInventoryIds(itemVariant) {
  return {
    type: LIBRARY_ITEM_SET_MANAGE_ITEM_INVENTORY,
    payload: { itemVariant },
  };
}

export function setActiveModifierIds(modifierIds) {
  return {
    type: LIBRARY_ITEM_SET_ACTIVE_MODIFIER_IDS,
    payload: { modifierIds },
  };
}

export function submitFormCreate(
  values,
  allOutlet,
  items,
  search,
  salesType,
  user,
  outlets,
  inStock,
  image
) {
  return {
    type: LIBRARY_ITEM_SUBMIT_FORM_CREATE,
    payload: {
      values,
      allOutlet,
      items,
      search,
      salesType,
      user,
      outlets,
      inStock,
      image,
    },
  };
}

export function submitFormUpdate(
  itemId,
  values,
  allOutlet,
  items,
  salesType,
  itemDetail,
  user,
  outlets,
  search,
  inStock,
  image
) {
  return {
    type: LIBRARY_ITEM_SUBMIT_FORM_UPDATE,
    payload: {
      itemId,
      values,
      allOutlet,
      items,
      salesType,
      itemDetail,
      user,
      outlets,
      search,
      inStock,
      image,
    },
  };
}

export function showDeleteModal() {
  return { type: LIBRARY_ITEM_SHOW_DELETE_MODAL, payload: {} };
}

export function showUpdateModal() {
  return { type: LIBRARY_ITEM_SHOW_UPDATE_MODAL, payload: {} };
}

export function hideDeleteModal() {
  return { type: LIBRARY_ITEM_HIDE_DELETE_MODAL, payload: {} };
}

export function hideUpdateModal() {
  return { type: LIBRARY_ITEM_HIDE_UPDATE_MODAL, payload: {} };
}

export function deleteItem(item, previousItems, search) {
  return {
    type: LIBRARY_ITEM_DELETE_ITEM,
    payload: { item, previousItems, search },
  };
}

export function onClickCreateNewCategory(
  category,
  previousCategories,
  previousCategoryId
) {
  return {
    type: LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY,
    payload: { category, previousCategories, previousCategoryId },
  };
}

export function onClickCreateNewBrand(brand, previousBrand, previousBrandId) {
  return {
    type: LIBRARY_ITEM_ON_CLICK_CREATE_NEW_BRAND,
    payload: { brand, previousBrand, previousBrandId },
  };
}

export function showNewCategoryModal() {
  return { type: LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL, payload: {} };
}

export function showNewBrandModal() {
  return { type: LIBRARY_ITEM_CREATE_BRAND_SHOW_MODAL };
}

export function hideNewBrandModal() {
  return { type: LIBRARY_ITEM_CREATE_BRAND_HIDE_MODAL };
}

export function hideNewCategoryModal() {
  return { type: LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL, payload: {} };
}

export function setNewCategory(category) {
  return { type: LIBRARY_ITEM_SET_NEW_CATEGORY, payload: { category } };
}

export function setNewBrand(brand) {
  return { type: LIBRARY_ITEM_SET_NEW_BRAND, payload: { brand } };
}

export function onConfirmCreateNewCategory(category) {
  return {
    type: LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY,
    payload: { category },
  };
}

export function onCancelCreateNewCategory(
  previousCategories,
  previousCategoryId
) {
  return {
    type: LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY,
    payload: { previousCategories, previousCategoryId },
  };
}

export function setPreviousCategories(categories) {
  return {
    type: LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES,
    payload: { categories },
  };
}

export function setPreviousBrand(brand) {
  return {
    type: LIBRARY_ITEM_SET_PREVIOUS_BRAND,
    payload: { brand },
  };
}

export function setPreviousBrandId(brandId) {
  return {
    type: LIBRARY_ITEM_SET_PREVIOUS_BRAND_ID,
    payload: { brandId },
  };
}

export function setPreviousCategoryId(categoryId) {
  return {
    type: LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID,
    payload: { categoryId },
  };
}

export function showImportModal() {
  return { type: LIBRARY_ITEM_SHOW_IMPORT_MODAL, payload: {} };
}

export function hideImportModal() {
  return { type: LIBRARY_ITEM_HIDE_IMPORT_MODAL, payload: {} };
}

export function onSuccessImport() {
  return { type: LIBRARY_ITEM_ON_SUCCESS_IMPORT, payload: {} };
}

export function setIsSubmittingForm(isSubmittingForm) {
  return {
    type: LIBRARY_ITEM_SET_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}

export function setRewardItemList(items) {
  return { type: LIBRARY_ITEM_SET_REWARD_ITEM_LIST, payload: { items } };
}

export function setRewardCategoryList(categories) {
  return {
    type: LIBRARY_ITEM_SET_REWARD_CATEGORY_LIST,
    payload: { categories },
  };
}

export function setRewardItemVariantList(itemVariants) {
  return {
    type: LIBRARY_ITEM_SET_REWARD_ITEM_VARIANT_OF,
    payload: { itemVariants },
  };
}

export function setPointGainItemList(items) {
  return { type: LIBRARY_ITEM_SET_POINT_GAIN_ITEM_LIST, payload: { items } };
}

export function setEcommerceCategory(payload) {
  return { type: LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY, payload };
}

export function setIsRetailEcommerce(isRetail) {
  return { type: LIBRARY_ITEM_SET_ITEM_IS_RETAIL, payload: { isRetail } };
}

export function setEcommerceCategoryFashion(payload) {
  return { type: LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY_FASHION, payload };
}

export function setPointGainCategoryList(categories) {
  return {
    type: LIBRARY_ITEM_SET_POINT_GAIN_CATEGORY_LIST,
    payload: { categories },
  };
}

export function setPointGainItemVariantList(itemVariants) {
  return {
    type: LIBRARY_ITEM_SET_POINT_GAIN_ITEM_VARIANT_OF,
    payload: { itemVariants },
  };
}

export function onRedirectSalesType() {
  return { type: LIBRARY_ITEM_ON_REDIRECT_SALES_TYPE, payload: {} };
}

export function setValidationModal(isOpen) {
  return { type: LIBRARY_ITEM_SET_VALIDATION_MODAL, payload: { isOpen } };
}

export function setValidationModalMessage(message) {
  return {
    type: LIBRARY_ITEM_SET_VALIDATION_MODAL_MESSAGE,
    payload: { message },
  };
}

export function itemExportStart(exportStatus) {
  return { type: LIBRARY_ITEM_ITEM_LIST_EXPORT_START, payload: exportStatus };
}

export function itemExportFinished() {
  return { type: LIBRARY_ITEM_ITEM_LIST_EXPORT_FINISHED, payload: {} };
}

export function itemExportError(error) {
  return { type: LIBRARY_ITEM_ITEM_LIST_EXPORT_ERROR, payload: error };
}

export function setBrandList(brands) {
  return { type: LIBRARY_ITEM_SET_BRAND_LIST, payload: { brands } };
}

export function onConfirmCreateNewBrand(brand, outletId) {
  return {
    type: LIBRARY_ITEM_CONFIRM_CREATE_NEW_BRAND,
    payload: { brand, outletId },
  };
}

export function setCustomCategoryFashionColorInput(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_INPUT,
    payload,
  };
}

export function setCustomCategoryFashionConstructData() {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA,
  };
}

export function setCustomCategoryFashionColorData(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
    payload,
  };
}

export function setCustomCategoryFashionColorDataNoSaga(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA_NO_SAGA,
    payload,
  };
}

export function unsetCustomCategoryFashionColorData(payload) {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
    payload,
  };
}

export function unsetCustomCategoryFashionColorAllData() {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA,
  };
}

export function unsetCustomCategoryFashionColorAllDataNoSaga() {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA_NO_SAGA,
  };
}

export function setCustomCategoryFashionMaterialInput(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_INPUT,
    payload,
  };
}

export function setCustomCategoryFashionMaterialData(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
    payload,
  };
}

export function setCustomCategoryFashionMaterialDataNoSaga(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA_NO_SAGA,
    payload,
  };
}

export function unsetCustomCategoryFashionMaterialData(payload) {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
    payload,
  };
}

export function unsetCustomCategoryFashionMaterialAllData() {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA,
  };
}

export function unsetCustomCategoryFashionMaterialAllDataNoSaga() {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA_NO_SAGA,
  };
}

export function setCustomCategoryFashionSizeInput(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_INPUT,
    payload,
  };
}

export function setCustomCategoryFashionSizeData(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
    payload,
  };
}

export function setCustomCategoryFashionSizeDataNoSaga(payload) {
  return {
    type: LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA_NO_SAGA,
    payload,
  };
}

export function unsetCustomCategoryFashionSizeData(payload) {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
    payload,
  };
}

export function unsetCustomCategoryFashionSizeAllData() {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA,
  };
}

export function unsetCustomCategoryFashionSizeAllDataNoSaga() {
  return {
    type: LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA_NO_SAGA,
  };
}

export const showUpdateToAllOutletsModal = () => {
  return {
    type: LIBRARY_ITEM_SHOW_UPDATE_ALL_OUTLET_MODAL,
  };
};

export const hideUpdateToAllOutletsModal = () => {
  return {
    type: LIBRARY_ITEM_HIDE_UPDATE_ALL_OUTLET_MODAL,
  };
};

export const showErrorUpdateAllOutletModal = () => {
  return {
    type: LIBRARY_ITEM_SHOW_ERROR_UPDATE_ALL_OUTLET_MODAL,
  };
};

export const hideErrorUpdateAllOutletModal = () => {
  return {
    type: LIBRARY_ITEM_HIDE_ERROR_UPDATE_ALL_OUTLET_MODAL,
  };
};
